<template>
<div>
  <template v-if="$route.name === 'EXSBBankCreate'">
    <b-row>
      <b-col>
        <router-link :to="{ name: 'EXSBBankList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body">
            <b-row>
              <b-col>
                <Form
                  :handle-submit="onSendForm"
                  :values="item"
                  :violations="violations"/>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </template>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        title: '',
        description: ''
      }
    }
  },
  watch: {
    created (val) {
      if (val) this.$router.push({ name: 'EXSBBankList' })
    }
  },
  beforeCreate () {
    checkPagePermission('finances', 'EXSBBankCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'exsbbank/create/created',
      violations: 'exsbbank/create/violations',
      isLoading: 'exsbbank/create/isLoading'
    })
  },
  methods: {
    onSendForm () {
      this.create(this.item)
    },
    ...mapActions({
      create: 'exsbbank/create/create',
      reset: 'exsbbank/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
